import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  AssignSeatRequest,
  SubscriptionResponse,
  UpgradeSubscriptionRequest,
} from '@core/billing/billing.models';
import { CRAPIError } from '@shared/models/error.models';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class BillingAPIService {
  private readonly http = inject(HttpClient);

  // Billing Endpoints
  private readonly baseCRURI = environment.chargeRepayBaseURL;
  private readonly subscriptionsEndpoint =
    environment.chargeRepayBaseURL + '/v2/billing/subscriptions';

  public getSubscriptions() {
    return this.http
      .get<SubscriptionResponse[]>(this.subscriptionsEndpoint, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .pipe(
        catchError((error) => {
          return this.handleError(error);
        }),
      );
  }

  public upgradeSubscription(subscriptionId: string, request: UpgradeSubscriptionRequest) {
    const upgradeEndpoint = `${this.subscriptionsEndpoint}/${subscriptionId}/upgrade`;
    return this.http
      .post<SubscriptionResponse>(upgradeEndpoint, request, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .pipe(
        catchError((error) => {
          return this.handleError(error);
        }),
      );
  }

  public assignSeat(subscriptionId: string, request: AssignSeatRequest) {
    const url = `${this.subscriptionsEndpoint}/${subscriptionId}/seats`;
    return this.http
      .put<void>(url, request, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .pipe(
        catchError((error) => {
          return this.handleError(error);
        }),
      );
  }

  public unassignSeat(subscriptionId: string, seatUserId: string) {
    const url = `${this.subscriptionsEndpoint}/${subscriptionId}/seats/${seatUserId}`;
    return this.http.delete<void>(url).pipe(catchError((error) => this.handleError(error)));
  }

  private handleError(error: HttpErrorResponse) {
    console.error(error?.error?.error?.id, error?.status);

    const errorMessage: CRAPIError = {
      statusCode: error?.status ?? 0,
      error_code: error?.error?.error?.id ? error?.error?.error?.id : 'UNKNOWN_ERROR',
    };

    return throwError(() => errorMessage);
  }
}
